



































import { KeyPair } from '@/types/KeyPair';
import axios from 'axios'
import {Component} from 'vue-property-decorator'
import {destroyApiV1AdminSessionPath} from '@/rails/routes'
import VueBase from '@/pages/vue-base'

@Component
export default class AdminIndex extends VueBase {
  MENUS = [
    { link: 'users', label: '登録者管理', icon: 'account-edit' },
    { link: 'applicants', label: '応募', icon: 'human-greeting' },
    { link: 'recruits', label: '求人情報', icon: 'domain' },
    { link: 'recommends', label: 'おすすめ求人', icon: 'lightbulb-on-outline' },
    { link: 'news', label: 'ニュース', icon: 'newspaper' },
    { link: 'new_jobs', label: '新着求人', icon: 'new-box' },
    { link: 'know_hows', label: '転職ノウハウ', icon: 'crosshairs-question' },
    // { link: 'advices', label: '沖縄移住相談室', icon: 'map-check' },
    { link: 'lives', label: '沖縄生活情報', icon: 'account-child' },
    { link: 'interviews', label: 'インタビュー', icon: 'account-voice' },
    // { link: 'staff_blogs', label: 'スタッフブログ', icon: 'post' },
    { link: 'media', label: 'メディア', icon: 'folder-multiple-image' },
    { link: 'events', label: 'イベント管理', icon: 'calendar-check' },
    { link: 'event_pages', label: 'イベントページ', icon: 'calendar-edit' },
    { link: 'messages', label: 'メルマガ', icon: 'email-send' },
  ]

  get activateMenus(): Array<KeyPair> {
    return this.MENUS.filter(menu => this.settings.admin.menus.includes(menu.link))
  }

  mounted(): void {
    if (this.$route.path.endsWith('/admin') || this.$route.path.endsWith('/admin/')) {
      this.$router.push('/admin/users')
    }
  }

  active(link): boolean {
    return location.pathname.includes(link)
  }

  async logout(): Promise<void> {
    const res = await axios.delete(destroyApiV1AdminSessionPath())
    if (res.status === 200) {
      localStorage.removeItem('auth')
      this.$router.push('/admin/login')
    } else {
      this.showError('ログアウトに失敗しました')
    }
  }
}
